import { formatNumberDecimals } from '@makemydeal/dr-common-utils';
import type { Row } from '../../types/RollToPaymentOptionRow';
import { formatMoneyFactor } from '../../utils/formatUtils';
import { ADJUSTABLE_FIELDS } from './constants/adjustableFields';
import { constants as offerReduxConstants } from '@makemydeal/dr-offer-redux';

export type RateRowInput = {
    rateType?: string;
    currentRate: number;
    rollToRate?: number;
    adjustRate: number;
};

const rateLabel = (rateType?: string): string => {
    if (rateType === offerReduxConstants.RATE_TYPE.APR) {
        return ADJUSTABLE_FIELDS.APR;
    }
    if (rateType === offerReduxConstants.RATE_TYPE.MoneyFactor) {
        return ADJUSTABLE_FIELDS.MONEY_FACTOR;
    }
    return '';
};

const formatRollToRate = (rateType?: string, rollToRate?: number): string =>
    rateType === offerReduxConstants.RATE_TYPE.MoneyFactor && rollToRate != null
        ? formatMoneyFactor(rollToRate)
        : formatNumberDecimals(rollToRate);

export const buildRateRow = ({ rateType, currentRate, rollToRate, adjustRate }: RateRowInput): Row => ({
    label: rateLabel(rateType),
    current: currentRate,
    rollTo: formatRollToRate(rateType, rollToRate),
    rollToRaw: rollToRate,
    key: 'rate',
    adjust: adjustRate,
    isAdjustableField: true,
    isMoneyFactorRate: rateType === offerReduxConstants.RATE_TYPE.MoneyFactor,
    inputPrefix: rateType === offerReduxConstants.RATE_TYPE.APR ? '%' : ''
});
